import { SxProps, Theme } from '@mui/material';

/**
 * Styles for the data grid container
 */
export const dataGridContainerStyles: SxProps<Theme> = {
  width: '100%',
  height: 'auto',
};

/**
 * Styles for the cell content
 */
export const cellContentStyles: SxProps<Theme> = {
  whiteSpace: 'pre',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

/**
 * Styles for the actions container
 */
export const actionsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
};
